import type { Itinerary } from "../interfaces/itinerary.interface";

export type DesktopVersion = "v1" | "v2" | "v3";
export type MobileVersion = "v1" | "v2" | "v3";
export type LayoutVersion = DesktopVersion | MobileVersion;

export function getDesktopVersion(itinerary?: Itinerary, desktopVersion?: string): DesktopVersion {
  if (desktopVersion === "2.1") return "v3";
  if (itinerary?.v2) return "v2";
  return "v1";
}

export function getMobileVersion(itinerary?: Itinerary): MobileVersion {
  if (itinerary?.v3) return "v3";
  if (itinerary?.v2) return "v2";
  return "v1";
}

export function getActiveVersion(itinerary?: Itinerary, isMobile?: boolean, desktopVersion?: string): LayoutVersion {
  return isMobile ? getMobileVersion(itinerary) : getDesktopVersion(itinerary, desktopVersion);
}
